import { Button, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { InfoBoxCard } from "./CampaignImpactInfoBoxCard";
import styles from "../CampaignImpact.module.css";

export const CampaignImpactInfoBoxCardError = () => {
  const i18n = useI18n();

  return (
    <InfoBoxCard
      backgroundColor="action_alt"
      title={i18n.trans(t("flights_airline_portal_airline_view_campaign_error_api_failure_header"))}
    >
      <Text variant="body_2">
        {i18n.trans(t("flights_airline_portal_airline_view_campaign_error_api_failure_body"))}
      </Text>
      <Button
        className={styles.refreshButton}
        variant="tertiary"
        onClick={() => window.location.reload()}
        text={i18n.trans(t("flights_airline_portal_airline_view_campaign_error_api_failure_button"))}
      />
    </InfoBoxCard>
  );
};
